export function LookupField({
  label,
  value,
  note,
}: {
  label: string
  value: string | number | null | undefined
  note?: string
}) {
  return (
    <>
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="flex items-center gap-2">
        {value == null || value === '' ? '—' : value}
        {note && <span className="text-muted-foreground text-xs">({note})</span>}
      </dd>
    </>
  )
}
